import { createSelector } from 'reselect'

export const getEquipment = createSelector(
  (state) => state && state.ads && state.ads.equipment && state.ads.equipment.elements && Array.isArray(state.ads.equipment.elements)
    ? state.ads.equipment.elements
    : [],
  (equipment) => equipment
)
